export default __webpack_public_path__ + "static/media/one-to-two.d4101db2.svg";